import React,{ Component } from "react";
import {connect} from 'dva';
import {Flex,Grid} from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css'; 
import 'antd-mobile/lib/date-picker/style'; 
import './My.css';

class My extends Component{
    constructor(props){
        super(props);
        this.state = {
            grid:[]

        };
    }
    componentDidMount(){
        this.props.dispatch({type:"index/Grid_module",payload:{
            AAA001:''
           }}).then(()=>{
    
            this.setState({
              grid:this.props.grid
            });
        });
    }
    render(){
        return(
            <div className="MyfullScreen" >
            <Flex >
                <img className="Myheadimgurl" src={localStorage.getItem("headimgurl")} alt={localStorage.getItem("nickname")}></img>
                <span style={{ fontSize: '20px', color: '#FF6E27' }}>{localStorage.getItem("AAC003")}</span>
            </Flex>
            <Grid data={this.state.grid}
            columnNum={4}
            renderItem={dataItem => (
    
            <div style={{ padding: '10px' }} onClick={(e)=> { this.props.dispatch({type:"weixin/changeRouter",payload:{route:dataItem.path}}) }} >
              <img src={dataItem.icon} alt="model" style={{ width: '60%', height: '60%' }}  />
              <div style={{ color: '#888', fontSize: '10px', marginTop: '6px' }}>
                <span>{dataItem.text}</span>
              </div>
            </div>
            
          )}
        />
            </div>
        );
    }
}

export default connect(state=>{
    return{
        ...state.index
    }
})(My) ;